import { useI18n } from '@change-corgi/core/react/i18n';
import { RadioGroup } from '@change-corgi/design-system-legacy/components/forms';
import { Image } from '@change-corgi/design-system-legacy/components/media';
import { Box } from '@change-corgi/design-system-legacy/layout';

import type { PetitionDetailsPageData } from 'src/app/pages/petitionGamma/details/pageContext';
import { RadioCard } from 'src/app/shared/components/forms';
import { ScrollContainer } from 'src/app/shared/components/ScrollContainer';

import { useShareVisualContents } from '../../hooks/useShareVisualContents';

type Petition = PetitionDetailsPageData['petition'];
type Context = 'petition_page';
type Props = { petition: Petition; context: Context; onChange: () => void };

export function ShareVisualContent({ petition, context, onChange }: Props): JSX.Element {
	const { data } = useShareVisualContents({ petition, context });
	const { translate } = useI18n();
	return (
		<RadioGroup
			aria-label={translate('corgi.petition_gamma.details.share_visuals.form_aria_label')}
			name="share-visuals"
			onChange={onChange}
			data-qa="share-visual-radio-group"
		>
			<ScrollContainer
				as="div"
				sx={{
					/* eslint-disable @typescript-eslint/naming-convention */
					'& > ul': {
						gridTemplateColumns:
							data.shareVisuals.length > 2
								? [
										`repeat(${data.shareVisuals.length}, minmax(219px, 1fr))`,
										`repeat(${data.shareVisuals.length}, minmax(31%, 1fr))`,
										`repeat(${data.shareVisuals.length}, minmax(22.5%, 1fr))`,
									]
								: 'repeat(2, 1fr)',
						paddingBottom: '24px',
						'& > li': {
							padding: 2,
						},
					},
					/* eslint-enable @typescript-eslint/naming-convention */
				}}
			>
				{data.shareVisuals.map((shareVisual) => (
					<RadioCard
						key={shareVisual.id}
						label={
							<Box
								sx={{
									aspectRatio: '1/1',
									backgroundColor: 'primary-greyBackground',
									padding: '8px 8px 0',
									lineHeight: 0,
								}}
							>
								<Image
									src={shareVisual.image.src}
									srcSet={shareVisual.image.srcSet}
									alt={shareVisual.image.alt}
									sx={{ borderRadius: 'standard' }}
								/>
							</Box>
						}
						value={shareVisual.variantName}
						data-qa={`share-visual-radio-card-${shareVisual.id}`}
					/>
				))}
			</ScrollContainer>
		</RadioGroup>
	);
}
